// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


// init Swiper:
const swiper = new Swiper('.tile-navigation-slider', {
    modules: [Pagination],
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: false,
    autoplay: false,
    spaceBetween: 32,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        992: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
    },
});
